import { render, staticRenderFns } from "./ContractVacationDaysInput.vue?vue&type=template&id=2bbe391a&"
import script from "./ContractVacationDaysInput.vue?vue&type=script&lang=js&"
export * from "./ContractVacationDaysInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports